enum NcrAlohaOrderMode {
  CallIn = 'CallIn',
  WalkIn = 'WalkIn',
  Web = 'Web',
  Delivery = 'Delivery',
  Curbside = 'Curbside',
  EatIn = 'EatIn',
  DriveThru = 'DriveThru',
  Catering = 'Catering',
  FaxedIn = 'FaxedIn',
  None = 'None',
}

export { NcrAlohaOrderMode };
